import { Routes, Route } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { AuthGate } from './auth/AuthGate';
import { AppShell } from './layout/AppShell';
import LoginPage from './pages/LoginPage';
import { EmpresasPage } from './pages/EmpresasPage';
import { EmpresaProfilePage } from './pages/EmpresaProfilePage';
import { InboxPage } from './pages/InboxPage';
import { PipelinePage } from './pages/PipelinePage';
import { ContatosPage } from './pages/ContatosPage';
import { EventosPage } from './pages/EventosPage';
import { ServicosPage } from './pages/ServicosPage';
import { DashboardPage } from './pages/DashboardPage';
import { TemplatesPage } from './pages/TemplatesPage';
import { TriagePage } from './pages/TriagePage';

export default function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route
          element={
            <AuthGate>
              <AppShell />
            </AuthGate>
          }
        >
          <Route index element={<DashboardPage />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="inbox" element={<InboxPage />} />
          <Route path="pipeline" element={<PipelinePage />} />
          <Route path="triage" element={<TriagePage />} />
          <Route path="empresas" element={<EmpresasPage />} />
          <Route path="empresas/:id" element={<EmpresaProfilePage />} />
          <Route path="contatos" element={<ContatosPage />} />
          <Route path="eventos" element={<EventosPage />} />
          <Route path="servicos" element={<ServicosPage />} />
          <Route path="templates" element={<TemplatesPage />} />
        </Route>
      </Routes>
    </AuthProvider>
  );
}
